import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './newpricemodal.scss'

// import components
import Modal from '../../components/Modal'
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'

// Actions
import { getPriceListimports } from '../../../actions/priceModel'

// Utils
import { translation } from '../../../utils/helpers'

// Elements
import Button from '../../elements/button'
import LabelWrapper from '../../elements/labelWrapper'

import { ModalIcons } from '../../elements/icons'

class NewPriceModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      selectedPriceModelId: 0,
      PriceModels: [{
        Id: 0,
        PriceType: -1,
        Name: 'New',
        IsCustomer: false,
        IsShop: false,
        IsChain: false
      }]
    }
    this.renderForm = this.renderForm.bind(this)
  }

  componentDidMount () {
    this.getPriceListimports()
  }

  componentWillReceiveProps (newProps) {
    // this.getPriceListimports()
  }

  addNew (data) {
    if (data === 0 || data === 1) {
      data = {
        Name: 'New',
        PriceModelId: 0,
        PriceType: -1,
        Department: data
      }
    }
    this.props.onCreate(data)
    this.props.onClose()
  }

  renderForm () {
    let PriceModels = [...this.state.PriceModels]
    let PriceModelsGrouped = {
      0: {
        name: '2029',
        items: []
      },
      1: {
        name: '700',
        items: []
      },
      2: {
        name: '58',
        items: []
      },
      3: {
        name: '2030',
        items: []
      }
    }
    // console.log('PriceModels ', PriceModels)
    // console.log('IsCustomer ', this.props.customer)
    const renderPriceModelList = () => {
      PriceModels.map((val) => {
        let added = false
        if (val.IsChain && hasSubscriptionPermission(this.props.auth, 10, 0)) {
          added = true
          PriceModelsGrouped[0].items.push(val)
        } else {
          // Make sure the skipped pricemodels are not grouped under "Other"
          added = true
        }
        if (val.IsShop) {
          added = true
          PriceModelsGrouped[1].items.push(val)
        }
        if (val.IsCustomer) {
          added = true
          PriceModelsGrouped[2].items.push(val)
        }
        if (!added) {
          PriceModelsGrouped[3].items.push(val)
        }
      })
      // console.log(PriceModelsGrouped[3])

      const renderPriceModelItem = (val, key) => {
        // let src = '/images/svgs/bodyshop-steps/Coating-White.svg'
        // if (val.Department === 1) src = '/images/svgs/bodyshop-steps/bodywork-2-white.svg'
        // {/* <img src={src} width='20' height='20' /> */}
        return (
          <Button key={key} style='link' onClick={this.addNew.bind(this, val)} labelText={val.Name} />
        )
      }

      return (
        <div>
          <ul>
            {Object.keys(PriceModelsGrouped).map((key) => {
              let group = PriceModelsGrouped[key]
              if (group.items.length === 0) return null
              return (
                <LabelWrapper key={key} labelText={translation(group.name)}>
                  {group.items.map(renderPriceModelItem)}
                </LabelWrapper>
              )
            })}
          </ul>
        </div>
      )
    }

    return (
      <div>
        {renderPriceModelList()}
      </div>
    )
  }

  getBottomBarProps () {
    if (this.props.customer === true) return null

    let departmentType = this.props.auth.departmentType
    switch (departmentType) {
      case 2:
        return {
          actionStyle: 'link',
          actionLabelText: translation('14875'),
          onActionClick: this.addNew.bind(this, 0),
          cancelStyle: 'link',
          cancelLabelText: translation('14874'),
          onCancelClick: this.addNew.bind(this, 1)
        }
      case 1:
      case 0:
        let text = translation('14875')
        if (departmentType === 1) {
          text = translation('14874')
        }

        return {
          actionLabelText: text,
          onActionClick: this.addNew.bind(this, departmentType)
        }
      default:
        return null
    }
  }

  getPriceListimports () {
    if (hasAccess([6], this.props.auth.user.UserType)) return null
    let customerId = 0
    if (this.props.activeCustomerId !== undefined) {
      customerId = this.props.activeCustomerId
    }

    this.props.getPriceListimports(customerId).then((res) => {
      this.setState({
        PriceModels: res.data
      })
    }, (err) => {
      console.log(err)
    })
  }

  render () {
    return (
      <div className='newprice_modal'>
        <Modal
          {...this.props}
          header={translation('1306')}
          overflowHidden={this.state.overflowHidden}
          icon={ModalIcons.Plus}
          bottomBarProps={this.getBottomBarProps()}
        >
          {this.renderForm()}
        </Modal>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPriceListimports
})(NewPriceModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewPriceModal/index.js